import React from "react";
import { DashboardWrapper } from "../components/DashboardWrapper/DashboardWrapper.styles";
import { useNotifications } from "../hooks/useNotification";
import { Card, Spin, Typography } from "antd";
import NotificationItem from "../components/Dashboard/NotificationItem";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const NotificationPage = () => {
  const { notifications, loading, handleNotificationClick, handleMarkAsRead } =
    useNotifications();

  const navigate = useNavigate();

  return (
    <DashboardWrapper>
      <Card
        style={{
          background: "rgba(88, 80, 109, 0.30)",
          borderRadius: 16,
        }}
      >
        <Title
          level={4}
          style={{ color: "#fff", marginBottom: 24, cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          ← All Notifications
        </Title>
        {loading ? (
          <Spin />
        ) : notifications.length === 0 ? (
          <Text style={{ color: "#94a3b8" }}>No notifications found</Text>
        ) : (
          notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onNotificationClick={handleNotificationClick}
              onMarkAsRead={handleMarkAsRead}
            />
          ))
        )}
      </Card>
    </DashboardWrapper>
  );
};

export default NotificationPage;
